import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Navigation, Pagination } from 'swiper/modules';
import SectionTitle from '../../components/SectionTitle';

import projectImg1 from '../../assets/img/slider/gemasan-23.svg';
import projectImg2 from '../../assets/img/slider/gemasan-22.svg';
import projectImg3 from '../../assets/img/slider/gemasan-20.svg';
import projectImg4 from '../../assets/img/slider/gemasan-23.svg';
import projectImg5 from '../../assets/img/slider/gemasan-20.svg';
import projectImg6 from '../../assets/img/slider/gemasan-22.svg';

const Project = () => {
  const sliderOption = {
    pagination: {
      el: '.project-slider-dots',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    spaceBetween: 30,
    slidesPerView: '3',
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
    },
  };

  return (
    <div id="robotik-kol" className="project__area project-height pt-90">
      <div className="container">
        <div className="row justify-content-center pb-60">
          <div className="col-xl-10 col-lg-12">
            <div className="project__section-box wow animate__fadeInUp text-center">
              <h4 className="section-subtitle">Robotik Kol</h4>
              <h3 className="section-title">
                Su Altı Operasyonlarında Yüksek Performanslı Robotik Kol Sistemi
              </h3>
              <div className="project__content" style={{ marginTop: '30px', maxWidth: '900px', margin: '30px auto 0' }}>
                <p style={{ 
                  fontSize: 'clamp(15px, 2vw, 18px)', 
                  lineHeight: '1.8', 
                  color: '#2a3658',
                  marginBottom: '0',
                  textAlign: 'center',
                  padding: '0 20px'
                }}>
                  Geliştirmekte olduğumuz Robotik Kol, su altı operasyonlarında kesme, kavrama, kurtarma ve onarım gibi karmaşık görevleri yüksek hassasiyetle gerçekleştirebilen çok fonksiyonlu bir manipülatör sistemidir. Modüler yapısı sayesinde farklı uygulamalara uyarlanabilen sistem, endüstriyel standartlarda performans sunmaktadır. Yüksek hassasiyet ve kontrol kabiliyeti ile su altı operasyonlarında kritik görevleri güvenli ve etkili bir şekilde yerine getirmek için tasarlanmıştır. Proje, TÜBİTAK 1507 Kobi Arge Programı tarafından desteklenmektedir.
                </p>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="project__section-arrow d-flex align-items-center justify-content-center" style={{ marginTop: '30px' }}>
              <div className="swiper-button swiper-button-prev">
                <button 
                  className="project-nav-button"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#2a3658';
                    e.currentTarget.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#2a3658';
                  }}
                  style={{ 
                    width: '50px', 
                    height: '50px', 
                    borderRadius: '50%', 
                    border: '2px solid #2a3658',
                    backgroundColor: '#ffffff',
                    color: '#2a3658',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                >
                  <i className="far fa-arrow-left" style={{ fontSize: '18px', color: '#2a3658' }}></i>
                </button>
              </div>
              <div className="swiper-button swiper-button-next">
                <button 
                  className="project-nav-button"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#2a3658';
                    e.currentTarget.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#2a3658';
                  }}
                  style={{ 
                    width: '50px', 
                    height: '50px', 
                    borderRadius: '50%', 
                    border: '2px solid #2a3658',
                    backgroundColor: '#ffffff',
                    color: '#2a3658',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    marginLeft: '15px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                >
                  <i className="far fa-arrow-right" style={{ fontSize: '18px', color: '#2a3658' }}></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="swiper-container project__active">
          <Swiper
            modules={[Pagination, Navigation, Mousewheel]}
            {...sliderOption}
            mousewheel={true}
            className="swiper-wrapper"
          >
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg1} alt="" />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg2} alt="" />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg3} alt="" />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg4} alt="" />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg5} alt="" />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg6} alt="" />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <div className="project__item">
                <Link to="/project-details">
                  <img src={projectImg3} alt="" />
                </Link>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="project-slider-dots"></div>
        </div>
      </div>
    </div>
  );
};

export default Project;
